export const FALLBACK_KEYWORDS = [
  { keyword: 'bio', func: 'bioGraph' },
  { keyword: '経歴', func: 'bioGraph' },
  { keyword: 'skill', func: 'skillTree' },
  { keyword: 'スキル', func: 'skillTree' },
  { keyword: 'interest', func: 'interestGraph' },
  { keyword: '興味', func: 'interestGraph' },

  { keyword: 'contact', func: 'contactInfo' },
  { keyword: '連絡', func: 'contactInfo' },
  { keyword: 'portfolio', func: 'portfolioSummary' },
  { keyword: 'ポートフォリオ', func: 'portfolioSummary' },
  { keyword: 'link', func: 'otherSiteLinks' },
  { keyword: 'リンク', func: 'otherSiteLinks' },
  { keyword: 'external', func: 'otherSiteLinks' },
  { keyword: 'profile', func: 'profileInfo' },
  { keyword: 'プロフィール', func: 'profileInfo' },
  { keyword: 'intro', func: 'briefIntro' },
  { keyword: '自己紹介', func: 'briefIntro' },
  { keyword: 'favorite programming language', func: 'favoriteLanguage' },
  { keyword: 'favorite language', func: 'favoriteLanguage' },
  { keyword: '好きな言語', func: 'favoriteLanguage' },
  { keyword: 'thesis', func: 'thesisSummary' },
  { keyword: '論文要約', func: 'thesisSummary' },
  { keyword: 'fusep', func: 'fusepThesisSummary' },
  { keyword: '夏研', func: 'fusepThesisSummary' },
  { keyword: 'graduation', func: 'graduationThesis' },
  { keyword: '卒業論文', func: 'graduationThesis' },
  { keyword: '卒論', func: 'graduationThesis' },
  { keyword: 'hpc-autoresearch', func: 'graduationThesis' },
  { keyword: 'project', func: 'majorProjects' },
  { keyword: 'プロジェクト', func: 'majorProjects' },
  { keyword: 'contribution', func: 'contributions' },
  { keyword: 'コントリビューション', func: 'contributions' },
  { keyword: 'oss', func: 'contributions' },
  { keyword: 'research', func: 'researchWorks' },
  { keyword: '研究', func: 'researchWorks' },
  { keyword: 'publication', func: 'researchWorks' },
  { keyword: '功績', func: 'researchWorks' },

  // Conversation functions
  { keyword: 'hello', func: 'greeting' },
  { keyword: 'hi', func: 'greeting' },
  { keyword: 'hey', func: 'greeting' },
  { keyword: 'こんにちは', func: 'greeting' },
  { keyword: 'やあ', func: 'greeting' },
  { keyword: 'はじめまして', func: 'greeting' },
  { keyword: 'thanks', func: 'thankYou' },
  { keyword: 'thank you', func: 'thankYou' },
  { keyword: 'ありがとう', func: 'thankYou' },
  { keyword: '感謝', func: 'thankYou' },
  { keyword: 'bye', func: 'goodbye' },
  { keyword: 'goodbye', func: 'goodbye' },
  { keyword: 'さようなら', func: 'goodbye' },
  { keyword: 'またね', func: 'goodbye' },
  { keyword: 'help', func: 'help' },
  { keyword: 'ヘルプ', func: 'help' },
  { keyword: '何が聞ける', func: 'help' },
  { keyword: 'what can', func: 'help' },
  { keyword: 'about this site', func: 'aboutThisSite' },
  { keyword: 'how was this made', func: 'aboutThisSite' },
  { keyword: 'このサイト', func: 'aboutThisSite' },
  { keyword: '技術スタック', func: 'aboutThisSite' },

  // Content functions
  { keyword: 'qualification', func: 'qualifications' },
  { keyword: '資格', func: 'qualifications' },
  { keyword: '学歴', func: 'qualifications' },
  { keyword: 'internship', func: 'workExperience' },
  { keyword: 'work experience', func: 'workExperience' },
  { keyword: 'インターン', func: 'workExperience' },
  { keyword: '職歴', func: 'workExperience' },
  { keyword: 'award', func: 'awards' },
  { keyword: '受賞', func: 'awards' },
  { keyword: '表彰', func: 'awards' },
{ keyword: 'goal', func: 'futureGoals' },
  { keyword: 'future', func: 'futureGoals' },
  { keyword: '目標', func: 'futureGoals' },
  { keyword: '将来', func: 'futureGoals' },
  { keyword: 'spoken language', func: 'spokenLanguages' },
  { keyword: 'what language do you speak', func: 'spokenLanguages' },
  { keyword: '話せる言語', func: 'spokenLanguages' },
  { keyword: '何語', func: 'spokenLanguages' },
  { keyword: 'tool', func: 'devEnvironment' },
  { keyword: 'environment', func: 'devEnvironment' },
  { keyword: 'setup', func: 'devEnvironment' },
  { keyword: '開発環境', func: 'devEnvironment' },
  { keyword: 'ツール', func: 'devEnvironment' },
] as const;

export type FunctionName = typeof FALLBACK_KEYWORDS[number]['func'];

export function fallbackSelectFunction(text: string): FunctionName | undefined {
  const normalized = text.toLowerCase();
  const found = FALLBACK_KEYWORDS.find(({ keyword }) =>
    normalized.includes(keyword)
  );
  return found?.func;
}

